import React from 'react';

import { connect } from 'utils/enhancedReduxConnect';
import { User } from '../../types/api/user';
import { Role } from '../../types/api/user/dictionaries';

interface Props {
  role: Role[] | Role;
  user: User;
}

export const checkAccess = (
  roles: Role[] | Role,
  user: Role[] | Role
): boolean => {
  const checkRoles = Array.isArray(roles) ? roles : [roles];
  const userRoles = Array.isArray(user) ? user : [user];

  if (!userRoles.length) return false;

  return userRoles.some((role) => checkRoles.includes(role));
};

export const forRole = (roles: Role[] | Role, user: Partial<User>): boolean => {
  const checkRoles = Array.isArray(roles) ? roles : [roles];
  const userRoles = user?.role || [];

  return checkAccess(checkRoles, userRoles);
};

const ForRole: React.FC<Props> = ({ children, role, user }) => {
  if (!checkAccess(role, user.role)) return null;

  if (typeof children !== 'function') {
    return children;
  }

  return children();
};

export default connect(({ me: { user } }) => ({ user }))(ForRole);
